"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsTokenListed = exports.isTokenListed = void 0;
var dayjs_1 = __importDefault(require("dayjs"));
var react_1 = require("react");
var _pool_1 = require("../../pool");
var utils_1 = require("../../shared/utils");
var isValid = function (time) {
    return time && time.match(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/);
};
// must be valid ISO: 2022-01-28T11:00:00.000Z
function isTokenListed(listingTime) {
    return isValid(listingTime) && (0, dayjs_1.default)().isAfter(listingTime);
}
exports.isTokenListed = isTokenListed;
function useIsTokenListed() {
    var listingTime = (0, _pool_1.usePool)().pool.token.listingTime;
    var _a = (0, react_1.useState)(isTokenListed(listingTime)), isListed = _a[0], setIsListed = _a[1];
    var listingDate = (0, react_1.useMemo)(function () { return (0, dayjs_1.default)(listingTime).utc(); }, [listingTime]);
    var isListingTimeUnknown = listingDate.hour() === 0 && listingDate.minute() === 0;
    var isValidListingTime = isValid(listingTime);
    (0, react_1.useEffect)(function () {
        if (!isListed && isValid(listingTime)) {
            var listingIn = (0, dayjs_1.default)(listingTime).utc().diff((0, dayjs_1.default)(), 'milliseconds');
            setTimeout(function () { return setIsListed(isTokenListed(listingTime)); }, Math.max(0, listingIn));
        }
    }, [isListed, listingTime]);
    var formatListingTime = (0, react_1.useCallback)(function (fullFormat, dayFormat, tbaString) {
        if (fullFormat === void 0) { fullFormat = utils_1.DateTimeFormat.full; }
        if (dayFormat === void 0) { dayFormat = utils_1.DateTimeFormat.dayOnly; }
        if (tbaString === void 0) { tbaString = 'TBA'; }
        if (!isValidListingTime) {
            return listingTime || tbaString;
        }
        var format = isListingTimeUnknown ? dayFormat : fullFormat;
        return listingDate.format(format);
    }, [isListingTimeUnknown, listingTime, listingDate, isValidListingTime]);
    return {
        isListed: isListed,
        isValidListingTime: isValidListingTime,
        listingDate: listingDate,
        formatListingTime: formatListingTime,
        isListingTimeUnknown: isListingTimeUnknown,
    };
}
exports.useIsTokenListed = useIsTokenListed;
